export type LegalSection = {
  title: string;
  content: string[];
};

export type LegalPageContent = {
  title: string;
  description: string;
  path: string;
  lastUpdated: string;
  sections: LegalSection[];
};

export type LegalPageSlug =
  | "aviso-legal"
  | "privacidad"
  | "cookies"
  | "condiciones"
  | "accesibilidad";

export const LEGAL_CONTACT_EMAIL = "lucentiasocial@gmail.com";
export const LEGAL_SITE_NAME = "Lucentia Social";
export const LEGAL_OWNER = "Jenifer Roelstraete";
export const LEGAL_NIF = "Z4407400F";
export const LEGAL_PHONE = "+34 604 445 729";
export const LEGAL_PHONE_E164 = "+34604445729";

export const LEGAL_ADDRESS = {
  street: "Calle General Primo de Rivera, 2",
  postalCode: "03002",
  city: "Alicante",
  region: "Comunidad Valenciana",
  country: "España",
  countryEn: "Spain",
  countryCode: "ES",
} as const;

export const LEGAL_POSTAL_CODE = LEGAL_ADDRESS.postalCode;

export const LEGAL_ADDRESS_LINE_ES = `${LEGAL_ADDRESS.street}, ${LEGAL_ADDRESS.postalCode} ${LEGAL_ADDRESS.city}, ${LEGAL_ADDRESS.country}`;
export const LEGAL_ADDRESS_LINE_EN = `${LEGAL_ADDRESS.street}, ${LEGAL_ADDRESS.postalCode} ${LEGAL_ADDRESS.city}, ${LEGAL_ADDRESS.countryEn}`;

export const LEGAL_MAPS_URL = "https://maps.app.goo.gl/q7yP7LyqhyaHMMYZA";

export type LegalBundle = Record<LegalPageSlug, LegalPageContent>;

export const LEGAL_SLUG_BY_PATH: Record<string, LegalPageSlug> = {
  "/aviso-legal": "aviso-legal",
  "/privacidad": "privacidad",
  "/cookies": "cookies",
  "/condiciones": "condiciones",
  "/accesibilidad": "accesibilidad",
};
